import React from 'react';
import _ from "lodash";

class BaseInputComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModified: false,
      isInvalid: false
    };
  }

  removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }

  componentWillMount() {
    if (this.props.data) {
      this.setState({
        value: this.props.data.getIn(this.props.keyPath),
      });
    }
  }

  getValue() {
    if (this.props.keyPath.length > 0) {
      return this.props.data.getIn(this.props.keyPath);
    }
    if (this.props.options !== undefined) {
      return this.props.options[0].text;
    }
    return '';
  }

  getKeyPathValue(keyPath) {
    if (keyPath.length > 0) {
      return this.props.data.getIn(keyPath);
    }
    if (this.props.options !== undefined) {
      return this.props.options[0].text;
    }
    return '';
  }

  getKeys() {
    let keys = [];
    if (!_.isEmpty(this.props.keyPathAliases)) {
      keys = keys.concat(
        this.props.keyPathAliases.map((keyPath) => keyPath.join('.'))
      );
    }
    keys.push(this.props.keyPath.join('.'));
    return keys;
  }

  componentWillReceiveProps(newProps) {
    if (this.props.backup && this.props.errors) {
      this.setState({
        isModified:
          newProps.data.getIn(this.props.keyPath) !=
          newProps.backup.getIn(this.props.keyPath),
        isInvalid: !_.isEmpty(
          _.intersection(
            newProps.errors.toJS().map((item) => item.key),
            this.getKeys()
          )
        ),
      });
    }
  }

  handleChange(newValue) {
    this.setState(
      {
        value: newValue,
      },
      () =>
        this.props.onDataChanged({
          key_path: this.props.keyPath,
          value: this.state.value,
        })
    );
  }
}

export default BaseInputComponent;



// WEBPACK FOOTER //
// ./src/components/common/BaseInputComponent.js